<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <h2>Truck Types</h2>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newTruckTypeModal">Add Truck Type</b-button>
              </b-col>
            </b-row>

            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table class="animated fadeIn" striped hover v-else bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" @row-clicked="rowClicked">

            </b-table>
            <b-row>
              <b-col  lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New  Modal-->
    <b-modal title="New Truck Types" v-model="newTruckTypes" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Truck Type" label-for="TruckTypeName" :label-cols="4" horizontal>
            <b-form-input type="text" v-model="TruckTypesName" class="form-control"/>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newTruckTypes=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveTruckTypes" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New Modal-->
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import trucktypes from './trucktypes'
  import services_service from '../services/services_service';

  Vue.use(VueSweetalert2)

  const items = []
  export default {
    name: 'mFluidTypes',
    created: function() {
      this.getAll()
      localStorage.removeItem("haulsaPage");
      localStorage.removeItem("targetsaPage");
      localStorage.removeItem("ftPage");
      localStorage.removeItem("targetPage");
      localStorage.removeItem("targetPage");
      localStorage.removeItem("oasaPage");
      localStorage.removeItem("reportPage");
			localStorage.removeItem("truckPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tcPage");
      localStorage.removeItem("userPage");
      if (!localStorage.tpPage) {
          localStorage.tpPage = 0;
      }
    },
    data() {
      return {
        trash: false,
        dpdt: 'Active',

        TruckTypesName: '',
        loadingData: true,
        TruckTypesId: null,
        newTruckTypes: false,
        items: items,
        fields: [
          {
          key: 'id',
          label: 'ID',
          sortable: true
        },
          {
          key: 'name',
          label: 'Truck Type',
          sortable: true
        },
       ],
        currentPage: parseInt(localStorage.tpPage),
        perPage: 25,
        totalRows: items.length,
        pageOptions: [25, 50, 100],
        sortBy: null,
        sortDesc: false,
        filter: null,
        selectedItems: ['id', 'name'],
        configTable: false,
        modalInfo: {
          title: '',
          content: ''
        },
        modalEdit: {
          title: ''
        },
				savebtn:true
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
      newTruckTypeModal() {
        this.TruckTypesName = ""
        this.savebtn=false
        this.newTruckTypes = true
      },
      rowClicked(row) {
        localStorage.tpPage = this.currentPage;
        localStorage.setItem('xyz', row.id)
        this.$router.push('/truck_type/' + row.id + '/')
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.currentPage = parseInt(localStorage.tpPage)
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      okToSave() {
				if (this.TruckTypesName === undefined || this.TruckTypesName.trim().length == 0) {
					this.$swal('Alert!', 'Truck Type can not be empty', 'warning')
					return false
				}

				return true
			},
      saveTruckTypes() {
        if (!this.okToSave()) {
					return
        }
        this.savebtn=true
        trucktypes.save(this.TruckTypesName)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
            if (data[0] == 'success') {
              this.newTruckTypes = false
              this.TruckTypesName = ''
              this.getAll()
            }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
      },
      getAll() {
        this.loadingData = true
        trucktypes.getAll()
          .then(data => {
            if (data.status == 'success') {
              this.items = data.truck_types
              this.loadingData = false

            }else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              // this.getAll()
              return
            }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/m_truck_types/m_truck_types.vue